"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartTextClick = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartTextClick(label, clickElementText, clickText, clickUrl) {
    let eventData;
    if (clickElementText && clickText) {
        eventData = {
            feature_category: enums_1.GA4FeatureCategory.Cart,
            eventName: enums_1.GA4EventName.ClickTextLink,
            click_element: clickElementText,
            click_text: clickText,
        };
    }
    if (clickUrl) {
        eventData = {
            ...eventData,
            click_url: clickUrl,
        };
    }
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.TEXT_CLICK,
        eventLabel: label,
        ...(eventData ? { eventData } : undefined),
    });
}
exports.trackCartTextClick = trackCartTextClick;
//# sourceMappingURL=trackCartTextClick.js.map